<script>
import Swal from '../../../js/sweetalert2.min.js';

export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            var msg = '가입하지 않은 회원입니다. \n 회원가입 페이지로 이동합니다. ';
            Swal.showLoading();
            swal(msg, {
                buttons: false,
                timer: 3000
            })
            .then(() => {
                this.$router.push('/signup')
            });
            Swal.close();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/MsgLogin.vue